module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control numericinput has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;\r\n             width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n             z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append("; \">\r\n\r\n    <div class=\"size-handle-top\"    style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n\r\n    <div class=\"pf-control-core pf-selectable ui-spinner ui-corner-all ui-widget ui-widget-content \"\r\n        style=\"margin: 1px;\r\n            height:")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n            width: ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\r\n                -webkit-border-radius: 0px;\r\n                -moz-border-radius: 0px;\r\n            border: ")
    ; __append(escapeFn(borderSize))
    ; __append("px ")
    ; __append(escapeFn(borderStyle))
    ; __append(" ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n            border-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px;\r\n            font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append("; font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n            font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n            line-height: ")
    ; __append(escapeFn( u.extractNum(height) - 5 ))
    ; __append("px;\r\n            color: ")
    ; __append(escapeFn(styleColorText))
    ; __append(";\r\n            background: ")
    ; __append(escapeFn(styleBGColorText))
    ; __append(";\">\r\n        <div id=\"spinner\" name=\"value\"  class=\"ui-spinner-input\" role=\"spinbutton\" aria-valuenow=\"-3\"\r\n                min=\"")
    ; __append(escapeFn( minValue ))
    ; __append("\" max=\"")
    ; __append(escapeFn( maxValue ))
    ; __append("\" step=\"")
    ; __append(escapeFn( stepSize ))
    ; __append("\"\r\n                style=\"margin: 1px;\r\n                height:")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n                width: ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\r\n                white-space: nowrap;\r\n                font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append("; font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n                font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n                color: ")
    ; __append(escapeFn(styleColorText))
    ; __append(";                \r\n                padding: 2px 5px 2px 5px;\r\n                background-color: ")
    ; __append(escapeFn(backgroundColor))
    ; __append(";\" >\r\n            <span>")
    ; __append(escapeFn( value ))
    ; __append("</span>\r\n            <a style=\"width: 40%\" tabindex=\"-1\" aria-hidden=\"true\" class=\"ui-button ui-widget ui-spinner-button ui-spinner-up ui-corner-tr ui-button-icon-only\" role=\"button\">\r\n                <span class=\"ui-button-icon ui-icon ui-icon-triangle-1-n\"></span>\r\n                <span class=\"ui-button-icon-space\"> </span>\r\n            </a>\r\n            <a  style=\"width: 40%\" tabindex=\"-1\" aria-hidden=\"true\" class=\"ui-button ui-widget ui-spinner-button ui-spinner-down ui-corner-br ui-button-icon-only\" role=\"button\">\r\n                <span class=\"ui-button-icon ui-icon ui-icon-triangle-1-s\"></span>\r\n                <span class=\"ui-button-icon-space\"> </span>\r\n            </a>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n</div>\r\n")
  }
  return __output;

}